/* @flow */
// typecheck: ignore file
import React from 'react';
import PeopleTableBodyContainer from 'components/PeopleTableBodyContainer.jsx';
import PeopleTableSuperActions from 'components/PeopleTableSuperActions.jsx';
import SmartTable from 'components/SmartTable.jsx';
import Group from 'entities/Group';

const FILTERS = [
  {
    name: 'roles',
    options: [
      { key: 'admin', name: 'Admins' },
      { key: 'teacher', name: 'Teachers' },
      { key: 'parent', name: 'Parents' },
      { key: 'student', name: 'Students' },
      { key: 'unknown', name: 'No role' },
    ],
  },
];

const nameSorts = [
  { key: 'first_name_asc', name: 'First name ascending' },
  { key: 'first_name_desc', name: 'First name descending', lastInSection: true },
  { key: 'last_name_asc', name: 'Last name ascending' },
  { key: 'last_name_desc', name: 'Last name descending' },
];

const dateJoinedSorts = [
  { key: 'join_date_desc', name: 'Descending' },
  { key: 'join_date_asc', name: 'Ascending' },
];

const roleSorts = [
  { key: 'role_desc', name: 'Descending' },
  { key: 'role_asc', name: 'Ascending' },
];

const COLUMNS = [
  { key: 'avatar', name: '' },
  { key: 'name', name: 'Name', sorts: nameSorts },
  { key: 'role', name: 'Role', sorts: roleSorts },
  { key: 'date_joined', name: 'Date joined', sorts: dateJoinedSorts },
  { key: 'actions', name: 'Actions' },
];

const INITIAL_SORT = 'first_name_asc';

type Props = {
  group: ?Group,
  namespace: string,
  disabled?: boolean,
}

class PeopleTable extends React.Component {
  props: Props;

  render() {
    const namespace = `people-list-${this.props.namespace}`;

    return (
      <div>
        {this.props.group && <PeopleTableSuperActions group={this.props.group} />}
        <SmartTable data-test="smart-table" withSearch hasActions namespace={namespace} filters={FILTERS} columns={COLUMNS} initialSort={INITIAL_SORT}>
          {({ query, sort, filters }) => (
            this.props.group &&
              <PeopleTableBodyContainer
                sort={sort}
                query={query}
                filters={filters}
                group={this.props.group}
                disabled={this.props.disabled}
              />
          )}
        </SmartTable>
      </div>
    );
  }
}

export default PeopleTable;



// WEBPACK FOOTER //
// ./src/components/PeopleTable.jsx